import PointLocation from '../../csr/models/PointLocation'

export interface CitationFromJson {
  balance_due: string
  citation_id: string
  driver_id: number|null
  enforcer_id: number
  id: number
  immobilization_case_id: number
  issued_at: string
  late_fee_due: string
  license_id: number
  location: PointLocation
  location_address: string
  operation_id: number
  original_amount_due: string
  status: string
  vehicle_id: number
  violation: string
  violation_at: string
  selected: boolean
}

class Citation {
  balanceDue: string
  citationId: string
  driverId: number|null
  enforcerId: number
  id: number
  immobilizationCaseId: number
  issuedAt: string|null
  lateFeeDue: string
  licenseId: number
  location: PointLocation
  locationAddress: string
  operationId: number
  originalAmountDue: string
  status: string
  vehicleId: number
  violation: string
  violationAt: string|null
  selected: boolean

  constructor (
    balanceDue: string,
    citationId: string,
    driverId: number|null,
    enforcerId: number,
    id: number,
    immobilizationCaseId: number,
    issuedAt: string|null,
    lateFeeDue: string,
    licenseId: number,
    location: PointLocation,
    locationAddress: string,
    operationId: number,
    originalAmountDue: string,
    status: string,
    vehicleId: number,
    violation: string,
    violationAt: string|null,
    selected: boolean
  ) {
    this.balanceDue = balanceDue
    this.citationId = citationId
    this.driverId = driverId
    this.enforcerId = enforcerId
    this.id = id
    this.immobilizationCaseId = immobilizationCaseId
    this.issuedAt = issuedAt || null
    this.lateFeeDue = lateFeeDue
    this.licenseId = licenseId
    this.location = location
    this.locationAddress = locationAddress
    this.operationId = operationId
    this.originalAmountDue = originalAmountDue
    this.status = status
    this.vehicleId = vehicleId
    this.violation = violation
    this.violationAt = violationAt || null
    this.selected = selected
  }

  static fromJson ({
    balance_due,
    citation_id,
    driver_id,
    enforcer_id,
    id,
    immobilization_case_id,
    issued_at,
    late_fee_due,
    license_id,
    location,
    location_address,
    operation_id,
    original_amount_due,
    status,
    vehicle_id,
    violation,
    violation_at,
    selected = true
  }: CitationFromJson) {
    return new Citation(
      balance_due,
      citation_id,
      driver_id,
      enforcer_id,
      id,
      immobilization_case_id,
      issued_at,
      late_fee_due,
      license_id,
      location,
      location_address,
      operation_id,
      original_amount_due,
      status,
      vehicle_id,
      violation,
      violation_at,
      selected
    )
  }
}

export default Citation
